import { render, staticRenderFns } from "./ArticleModal.vue?vue&type=template&id=17f2d047&"
import script from "./ArticleModal.vue?vue&type=script&lang=js&"
export * from "./ArticleModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports